'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M160 448l352 352 352-352h-224v-384h-256v384z' }),
        React.createElement('path', { d: 'M896 512v384h-768v-384h-128v416c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-416h-128z' })
    ));
};